import {useQuery} from "react-query";
import {GradingData, GradingResponse, GradingSummaryResponse} from "../types/responses/gradingResponse";
import DataRequest from '../queries/DataRequest';
import { getInspectedGradeAsync } from "../services/InspectionsServices";

export const getGrades = (inspectionId: string, user: any) => {
    return useQuery("grading", async () => {
        const gradingData = await getGradingData(inspectionId, user);

        const gradingSummaries = await getGradingSummaries(inspectionId, user);

        gradingData.vesselGrades.forEach(grade => {
            grade.summaryText = gradingSummaries.find(e => e.title == grade.name)?.description ?? "";
        });

        gradingSummaries.forEach(summary => {
            summary.grade = gradingData.vesselGrades.find(g => g.name == summary.title)?.score;
        });

        const data : GradingData = {
            conditionSummaries: gradingSummaries,
            gradingInformation: gradingData
        }

        return data;
    });
}

const getGradingData = async (inspectionId: string, user: any): Promise<GradingResponse> => {
    return await DataRequest(inspectionId, "grading", user);
}

const getGradingSummaries = async (inspectionId: string, user: any): Promise<GradingSummaryResponse[]> => {
    return await DataRequest(inspectionId, "conditionSummaries", user);
}

export const getInspectedGradeQuery = (inspectionId: string, imo: string, isCopy: boolean) => {
    return useQuery("inspectedGrade", async () => {
        return await getInspectedGradeAsync(inspectionId, imo, isCopy);
    }, {
        enabled: !!inspectionId && !!imo,
        cacheTime: 1000 * 60 * 15, // 5 minutes,
        staleTime: 1000 * 60 * 15, // 5 minutes
    });
}